import CryptoJS from 'crypto-js';

export function encryptPassword(password?: string) {
  return CryptoJS.AES.encrypt(String(password ?? ''), 'Z9ekXiSFpyh2IXvE').toString();
}
